import React from 'react';
import MaskedInput from 'react-text-mask';

const CustomMaskedInput = ({ inputRef, classes, value, ...props }: any) => {
  const valueAsString = String(value);
  return (
    <MaskedInput
      {...props}
      value={valueAsString}
      mask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      guide={false}
      placeholder="mm-dd-yyyy"
      inputMode="numeric"
    />
  );
};

export default CustomMaskedInput;
